import Vue from 'vue'
let vm = new Vue();
const Utils = {};

Utils.getCurrentTime = function(){
	const timeDate = new Date();
	const year = timeDate.getFullYear();
	const month = (timeDate.getMonth() + 1).toString().padStart(2, 0);
	const day = timeDate.getDate().toString().padStart(2, 0);
	const hour = timeDate.getHours().toString().padStart(2, 0);
	const minute = timeDate.getMinutes().toString().padStart(2, 0);
	const second = timeDate.getSeconds().toString().padStart(2, 0);
	const millisecond = timeDate.getMilliseconds().toString().padStart(3,0);
	return year + '' + month + '' + day + '' + hour + '' + minute + '' + second + '' + millisecond;
}

export default Utils;